import * as React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { LoginScreen, SignupScreen, ForgotPasswordScreen } from '../screens';

export const AuthStack = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/signup" element={<SignupScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
